import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Col, Label, Row } from "reactstrap"
import logo from "../../assets/images/logo-hoz_black.png";
// import logo from "../../assets/images/logo-nutri.svg";
const List = (props: any) => {
    const { data } = props

    return (
        <div className="header__print mt-4" style={{borderBottom: "1px dashed #000000"}}>
            <div className="header__logo">
                <img src={logo} alt="" height="100" />
            </div>
            <div className="header__content">
                <div className="item">
                    <Label className="value-text title" style={{ fontSize: "18px" }}>
                        Phòng khám dinh dưỡng nhi Dr.Nutri
                    </Label>
                </div>
                <div className="item">
                    <Label>Địa chỉ:</Label>
                    <div className="value-text">{data?.address}</div>
                </div>
                <div className="item d-flex">
                    <div className="d-flex">
                        <Label>Điện thoại:</Label>
                        <div className="value-text">
                            {data?.phone}
                        </div>
                    </div>
                    <div className="d-flex" style={{ marginLeft: 30 }}>
                        <Label>Email:</Label>
                        <div className="value-text">{data?.email}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default List